import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, HStack, Text } from '@chakra-ui/react';

import {
  getBankAccountDisplayName,
  parseBankAccountIllustrationName,
} from 'common/bankAccount/utils';
import { formatAmount } from 'common/formatAmount';
import Button from 'components/_core/Button';
import SunshineIcon from 'components/_core/SunshineIcon';
import BankAccountIcon, {
  BankAccountIllustrationName,
} from 'components/BankAccountIcon';
import * as routes from 'features/Bank/routes';

import locales from './locales';

interface BankAccountCardProps {
  accountType: string;
  bankAccountId: string;
  balance: number;
  currency: string;
  illustrationName: BankAccountIllustrationName | null;
  name: string;
}

const BankAccountCard: FC<BankAccountCardProps> = ({
  accountType,
  balance,
  bankAccountId,
  currency,
  illustrationName,
  name,
}) => {
  return (
    <Box
      _hover={{
        borderColor: 'grey.400',
      }}
      borderColor="grey.300"
      borderRadius="radius-16"
      borderWidth="1px"
      overflow="hidden"
    >
      <HStack
        _hover={{
          backgroundColor: 'grey.100',
        }}
        as={Link}
        padding="space-16"
        spacing="space-16"
        to={routes.getBankAccountPath(bankAccountId)}
      >
        <BankAccountIcon
          illustrationName={parseBankAccountIllustrationName(illustrationName)}
          size="lg"
        />
        <Box flex={1} overflow="hidden">
          <Text
            color="grey.800"
            fontSize="font-18"
            fontWeight="weight-500"
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {getBankAccountDisplayName({ name, type: accountType })}
          </Text>
          <Text color="grey.700" fontSize="font-15">
            {formatAmount({
              currency,
              forcePlusSign: false,
              value: balance,
            })}
          </Text>
        </Box>
        <SunshineIcon color="grey.600" name="chevron-right" size="icon-24" />
      </HStack>
      <HStack paddingBottom="space-16" paddingX="space-16" spacing="space-20">
        <Button
          as={Link}
          to={routes.getBankAccountDetailsPath(bankAccountId)}
          variant="inline-secondary"
        >
          {locales.ibanLinkTitle}
        </Button>
      </HStack>
    </Box>
  );
};

export default BankAccountCard;
